import React, { useState, useEffect, useRef } from "react";
import styles from "./carManage.module.css";
import { BarLoader } from "react-spinners";
import crashImage from "../../assets/images/gallery.svg";

function removeItems(arr, item) {
  for (var i = 0; i < item; i++) {
    arr.pop();
  }
}

const onImageError = (ev) => {
  ev.target.src = crashImage;
};

function useFiles({ initialState = [], maxFiles }) {
  const [state, setstate] = useState(initialState);
  function withBlobs(files) {
    const destructured = [...files];
    if (destructured.length > maxFiles) {
      const difference = destructured.length - maxFiles;
      removeItems(destructured, difference);
    }
    const blobs = destructured
      .map((file) => {
        if (file.type.includes("image")) {
          file.preview = URL.createObjectURL(file);
          return file;
        }
        return null;
      })
      .filter((elem) => elem !== null);

    setstate(blobs);
  }
  return [state, withBlobs];
}

function UploadEdit({ onDrop, maxFiles = 1, img, imageUploadLoader }) {
  const [over, setover] = useState(false);
  const [files, setfiles] = useFiles({ maxFiles });
  const [uploaded, setUploaded] = useState(false);

  const $input = useRef(null);
  useEffect(() => {
    if (onDrop) {
      onDrop(files);
    }
  }, [files]);
  return (
    <>
      <div
        onClick={() => {
          $input.current.click();
          setUploaded(true);
        }}
        onDrop={(e) => {
          e.preventDefault();
          e.persist();
          setfiles(e.dataTransfer.files);
          setover(false);
          setUploaded(true);
        }}
        onDragOver={(e) => {
          e.preventDefault();
          setover(true);
        }}
        onDragLeave={(e) => {
          e.preventDefault();
          setover(false);
        }}
        className={styles.dragAndDrop}
      >
        <div className={styles.dragAndDrop}>
          {!uploaded && <img src={img} alt="upload" />}
          {uploaded && (
            <div className="blob-container">
              {/* <h2>File Previews</h2> */}
              {files.map((file) => (
                <img
                  key={file.name + "file"}
                  src={file.preview}
                  alt="your file"
                  onError={onImageError}
                />
              ))}
              {imageUploadLoader && (
                <div className="a">
                  <BarLoader height={"20px"} color="#031569" />
                </div>
              )}
              {/* <p>{JSON.stringify(files.length)}</p> */}
            </div>
          )}

          <p className={styles.reSelect}>Reselect image</p>

          {/* {uploaded && <p className={styles.reSelect}>Reselect Image</p>} */}
        </div>

        <input
          style={{ display: "none" }}
          type="file"
          accept="image/*"
          ref={$input}
          onChange={(e) => {
            setfiles(e.target.files);
          }}
          multiple={maxFiles > 1}
        />
      </div>
      {/* <p className="imageSuggest">*Suggested image size : 1920x1080</p> */}
    </>
  );
}

export { UploadEdit };
